import React from 'react';
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DyamicDropdown';
import { useFilters } from '../FilterContext';
import { useDefectStatus, GROUP_MEMBERS } from './hooks/useDefectStatus';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { SHOW_ALL_OPTION } from '../constants';

export const DefectStatusFilter = () => {
	const { filterValues, updateFilter, isShowAll } = useFilters();
	const showAllEnabled = isShowAll('defectStatus');
	const allDefectStatuses = useDefectStatus(showAllEnabled);
	
	// Include parent status options for initialization lookup, but they'll be rendered as group headers
	const defectStatuses = allDefectStatuses;

	// Filter out parent status options from dropdown dataSource to prevent duplicates
	const dropdownDataSource = defectStatuses.filter(status => 
		!(status.id === "C" && status.name === "All Complete") &&
		!(status.id === "O" && status.name === "All Outstanding")
	);

	useFilterInitialization('defectStatus', defectStatuses, {
		waitForData: true,
    persistAll: true,
		getDefaultValue: () => GROUP_MEMBERS.find(member => member.name === "All Outstanding"),
		getParams: (item) => {
			// For grouped selections (All Complete/All Outstanding), use statusType
			if (item.id === "C" || item.id === "O") {
				return { defectStatusType: item.id, defectStatusID: "" };
			}
			// For Show All
			if (item.id === "") {
				return { defectStatusID: "", defectStatusType: "" };
			}
			// For individual status selections
			return { defectStatusID: item.id, defectStatusType: "" };
		}
	});

	if (!filterValues.defectStatus) {
		return null;
	}

	return (
		<Grid item lg={3} md={6} xs={12}>
			<DyanamicDropdown
				dataSource={dropdownDataSource}
				columns={[{ name: 'name', id: 1, minWidth: '130px' }]}
				columnsMinWidths={[140, 140, 140, 140, 140]}
				showHeader={false}
				width="100%"
				placeholder="Select Status"
				onChange={item => {
					let params;
					// For grouped selections (All Complete/All Outstanding), use statusType
					if (item.id === "C" || item.id === "O") {
						params = { defectStatusType: item.id, defectStatusID: "" };
					}
					// For Show All
					else if (item.id === "") {
						params = { defectStatusID: "", defectStatusType: "" };
					}
					// For individual status selections
					else {
						params = { defectStatusID: item.id, defectStatusType: "" };
					}
					updateFilter('defectStatus', item, params, true);
				}}
				selectdValueToshow="name"
				selectedValue={filterValues.defectStatus?.value}
				label="Filter by Status"
				isServerSide={false}
				icon={<FilterListIcon style={{ color: 'rgb(48, 122, 215)' }} />}
				required={false}
				showBorderColor
				groupBy={[
					SHOW_ALL_OPTION,
					...GROUP_MEMBERS,
				]}
				hasGroup
			/>
		</Grid>
	);
}; 
